import BigPicture from 'bigpicture'
// import lozad from 'lozad'

export default {
	init() {
		let { Macy } = window

		Macy({
			container: '#testimonial_grid',
			columns: 3,
			margin: 15,
			useContainerForBreakpoints: true,
			breakAt: {
				1100: {
					columns: 2,
				},
				700: {
					columns: 1,
					margin: {
						y: 20,
					},
				},
				350: {
					margin: {
						y: 14,
					},
				},
			},
		})

		// let observer = lozad()
		// observer.observe()
	},
	finalize() {
		let $links = $('.testimonial-box > a')
		if ($links.length) {
			$links.on('click', function (e) {
				let $this = $(this)
				let ytSrc = $this.data('youtubeId')
				if (!ytSrc) {
					return
				}
				e.preventDefault()
				BigPicture({
					el: this,
					ytSrc,
				})
			})
		}
	},
}
